import React from "react";
import ImageMain from "./About.png";

function About() {
  return (
    <div>
      <img alt="main" src={ImageMain} height="600" width="1900" />
    </div>
  );
}

export default About;
